/**
 * NOTE: CODEGEN IS USED IN THIS FILE. Careless manual edits may be lost.
 *
 * server/tools/syncDirs.ts keeps this file in sync with:
 *   server/src/shared/legacyTypes/fetchClassesTypes.ts
 */

import {Type, Static} from "@sinclair/typebox";
import {Nullable} from "../Types";

export const dayOfWeekT = Type.Union([
	Type.Literal("monday"),
	Type.Literal("tuesday"),
	Type.Literal("wednesday"),
	Type.Literal("thursday"),
	Type.Literal("friday"),
	Type.Literal("saturday"),
	Type.Literal("sunday"),
]);

export type DayOfWeek = Static<typeof dayOfWeekT>;

export const DAY_OF_WEEK_MAP = {
	MONDAY: "monday",
	TUESDAY: "tuesday",
	WEDNESDAY: "wednesday",
	THURSDAY: "thursday",
	FRIDAY: "friday",
	SATURDAY: "saturday",
	SUNDAY: "sunday",
} as const satisfies Record<string, DayOfWeek>;

export const enrollStatusT = Type.Union([
	Type.Literal("open"),
	Type.Literal("closed"),
	Type.Literal("full"),
	Type.Literal("waitlist"),
]);

export type EnrollStatus = Static<typeof enrollStatusT>;

export const ENROLL_STATUS_MAP = {
	OPEN: "open",
	CLOSED: "closed",
	FULL: "full",
	WAITLIST: "waitlist",
} as const satisfies Record<string, EnrollStatus>;

export const legacyDateT = Type.Object({
	date: Type.String(),
	timezoneType: Type.Number(),
	timezone: Type.String(),
});

export const legacyClassT = Type.Object({
	classId: Type.String(),
	courseId: Type.String(),
	name: Type.String(),
	instructorUserId: Type.String(),
	instructorPlatformId: Nullable(Type.String()),
	openSpots: Type.String(),
	isVisible: Type.String(),
	studentEnrollment: Type.String(),
	schedule: Type.String(),
	maxEnrollment: Type.String(),
	cost: Type.String(),
	classroomId: Type.String(),
	waitlisted: Type.String(),
	seasonId: Type.String(),
	dateStartAt: Type.String(),
	timeStartAt: Type.String(),
	campusId: Type.String(),
	isActive: Type.String(),
	teacher: Nullable(Type.String()),
	registerDeadlineAt: Type.String(),
	isPipeline: Type.String(),
	isExact: Type.String(),
	lumen: Nullable(Type.String()),
	invited: Type.String(),
	isStretch: Type.String(),
	isClosed: Type.String(),
	dateEndAt: Type.String(),
	timeEndAt: Type.String(),
	bookBundleId: Nullable(Type.String()),
	ebookSku: Type.String(),
	dow: Type.Array(dayOfWeekT),
	start: legacyDateT,
	end: legacyDateT,
	startInCampusTimezone: legacyDateT,
	endInCampusTimezone: legacyDateT,
	isSummer: Type.Boolean(),
	enrollStatus: enrollStatusT,
});

export const bookT = Type.Object({
	sku: Type.String(),
	name: Type.String(),
});

export const fetchClassesForCourseByCampusIdResponseT = Type.Object({
	classes: Type.Record(Type.String(), Type.Array(legacyClassT)),
	timestamp: Type.String(),
	success: Type.Boolean(),
});

export type LegacyDate = Static<typeof legacyDateT>;
export type LegacyClass = Static<typeof legacyClassT>;
export type Book = Static<typeof bookT>;
export type FetchClassesForCourseByCampusIdResponse = Static<
	typeof fetchClassesForCourseByCampusIdResponseT
>;
